import React from "react";
import PropTypes from "prop-types";
import StyledButton from "../StyledButton/StyledButton";
import styled, { withTheme } from "styled-components";

const StyledOutlineBtn = styled(StyledButton)`
  color: ${(props) =>
    props?.type === "danger"
      ? props?.theme?.chiliRed
      : props?.theme?.yellowGreen} !important;
  background-color: ${(props) => props?.theme?.glassy} !important;
  border-color: ${(props) =>
    props?.type === "danger"
      ? props?.theme?.chiliRed
      : props?.theme?.yellowGreen} !important;

  &.show-icon {
    position: relative;
    padding: 0.5rem 1rem 0.5rem 2rem;
    min-width: 130px;
    &:last-child {
      margin-left: 4px;
    }
    i {
      position: absolute;
      left: 15px;
      top: 12px;
    }
  }
`;

const OutlineButton = (props) => {
  const { text, size, type = "accent", icon = null } = props;

  return (
    <StyledOutlineBtn
      {...props}
      size={size}
      type={type}
      className={`${icon && "show-icon btn-sm"}`}
    >
      {icon && <i className={icon} />}
      {text || props.children}
    </StyledOutlineBtn>
  );
};

OutlineButton.propTypes = {
  size: PropTypes.oneOf(["lg", "", "sm"]),
  text: PropTypes.string,
  type: PropTypes.oneOf(["danger", "accent"]),
};

export default withTheme(OutlineButton);
